import styled from 'styled-components/macro';

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
`;

export default InputContainer;
